function getHeight() {
    const d = document;
    return Math.max(
        d.body.scrollHeight, d.documentElement.scrollHeight,
        d.body.offsetHeight, d.documentElement.offsetHeight,
        d.body.clientHeight, d.documentElement.clientHeight,
    );
}

function getWidth() {
    const d = document;
    return Math.max(
        d.body.scrollWidth, d.documentElement.scrollWidth,
        d.body.offsetWidth, d.documentElement.offsetWidth,
        d.body.clientWidth, d.documentElement.clientWidth,
    );
}

export default {
    getWidth,
    getHeight,
}
